<template>
  <aside class="adm-sidebar">
    <div class="adm-sidebar__brand">
      <span class="adm-sidebar__name">Parkos Admin</span>
      <span class="adm-sidebar__sub">Panel de superadministrador</span>
    </div>

    <nav class="adm-sidebar__nav" aria-label="Panel de superadministrador">
      <router-link
        v-for="item in mainItems"
        :key="item.to"
        :to="item.to"
        class="adm-sidebar__item"
        :class="{ 'adm-sidebar__item--active': route.path.startsWith(item.to) }"
      >
        <span class="mdi" :class="item.icon"></span>
        {{ item.label }}
      </router-link>
    </nav>

    <div class="adm-sidebar__bottom">
      <router-link
        to="/superadmin/sistema"
        class="adm-sidebar__item"
        :class="{ 'adm-sidebar__item--active': route.path.startsWith('/superadmin/sistema') }"
      >
        <span class="mdi mdi-heart-pulse"></span>
        Sistema
      </router-link>
      <button type="button" class="adm-sidebar__item" @click="onLogout">
        <span class="mdi mdi-logout"></span>
        Cerrar sesión
      </button>
    </div>
  </aside>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'
import { useSuperadminStore } from '@/services/superadminStore'
import './adminShared.css'

const route = useRoute()
const router = useRouter()
const { signOut } = useSuperadminStore()

const mainItems = [
  { to: '/superadmin/dashboard', label: 'Dashboard', icon: 'mdi-view-dashboard-outline' },
  { to: '/superadmin/parques', label: 'Parques', icon: 'mdi-factory' },
  { to: '/superadmin/usuarios', label: 'Usuarios', icon: 'mdi-account-multiple-outline' },
  { to: '/superadmin/facturacion', label: 'Facturación', icon: 'mdi-receipt-text' },
  { to: '/superadmin/bitacora', label: 'Bitácora', icon: 'mdi-clipboard-text-clock' },
]

async function onLogout() {
  await signOut()
  // Tras salir, la ruta vuelve a comportarse como una página inexistente.
  router.push('/superadmin/acceso')
}
</script>

<style scoped>
.adm-sidebar {
  width: 220px; flex-shrink: 0; height: 100%; display: flex; flex-direction: column;
  background: #1e3a5f; color: #fff;
  /* Franja roja permanente: indica que estás en el panel de administración, no en un cliente. */
  border-right: 3px solid #e84545;
}
.adm-sidebar__brand {
  height: 56px; padding: 0 20px; flex-shrink: 0; display: flex; flex-direction: column; justify-content: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.adm-sidebar__name { font: 700 14px var(--font-display); color: #fff; line-height: 1.2; }
.adm-sidebar__sub { font: 400 10px Inter, sans-serif; color: rgba(255, 255, 255, 0.6); }
.adm-sidebar__nav { flex: 1; padding: 12px 10px; display: flex; flex-direction: column; gap: 2px; }
.adm-sidebar__bottom { padding: 10px; display: flex; flex-direction: column; gap: 2px; border-top: 1px solid rgba(255, 255, 255, 0.12); }
.adm-sidebar__item {
  display: flex; align-items: center; gap: 10px; width: 100%; padding: 10px 12px; border-radius: 6px; border: none;
  background: none; cursor: pointer; font: 500 13px Inter, sans-serif; color: rgba(255, 255, 255, 0.7); text-decoration: none; text-align: left;
}
.adm-sidebar__item .mdi { font-size: 18px; }
.adm-sidebar__item:hover { background: rgba(255, 255, 255, 0.08); color: #fff; }
.adm-sidebar__item--active { background: rgba(255, 255, 255, 0.14); color: #fff; }

@media (max-width: 768px) {
  .adm-sidebar { width: 64px; }
  .adm-sidebar__brand { padding: 0 8px; align-items: center; }
  .adm-sidebar__sub { display: none; }
  .adm-sidebar__name { font-size: 11px; text-align: center; }
  .adm-sidebar__item { justify-content: center; font-size: 0; gap: 0; padding: 12px 0; }
  .adm-sidebar__item .mdi { font-size: 20px; }
}
</style>